import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SubmitProposalButtonProps extends ButtonProps {
  showIcon?: boolean;
  text?: string;
}

const StyledButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(45deg, #8A2BE2, #00CC99)',
  color: '#fff',
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.spacing(2),
  textTransform: 'none',
  fontWeight: 600,
  boxShadow: '0 4px 20px rgba(138, 43, 226, 0.3)',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: 'linear-gradient(45deg, #8A2BE2, #00CC99)',
    boxShadow: '0 6px 25px rgba(138, 43, 226, 0.5)',
    transform: 'translateY(-2px)',
  },
}));

const SubmitProposalButton: React.FC<SubmitProposalButtonProps> = ({ 
  showIcon = true, 
  text = 'Submit Proposal',
  ...props 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/submit-proposal');
  };

  return (
    <StyledButton
      onClick={handleClick}
      startIcon={showIcon ? <Plus size={18} /> : null}
      {...props}
    >
      {text}
    </StyledButton>
  );
};

export default SubmitProposalButton; 